import { createSelector } from '@ngrx/store';
import { SharedState } from '../reducers';

export const selectRouterState = (state: SharedState) => state.router.state;
export const selectRouterUrl = createSelector(selectRouterState, (s) => s && s.url);
export const selectRouterParams = createSelector(selectRouterState, (s) => s && s.params);
export const selectRouterData = createSelector(selectRouterState, (s) => s && s.data);
